import axios from "axios";

export const state = {
    roles: [],
};

export const getters = {
    roles: state => state.roles,
};

export const mutations = {
    setRoles(roles, newValue) {
        state.roles = newValue
    },
};

export const actions = {
    fetchRoles({ commit }) {
        axios.get('/systemroles').then(res => {
            commit('setRoles', res.data.roles)
        })
    },
};
